// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fY4y","content":"styles_content__3H8BE","row":"styles_row__4D6qU","footer":"styles_footer__1nu9M","phraseLength":"styles_phraseLength__21tUd"};